__turbopack_context__.v({
  "card": "AiInRecruitingUseCasesSection-module__mFsa7q__card",
  "cardDesc": "AiInRecruitingUseCasesSection-module__mFsa7q__cardDesc",
  "cardTitle": "AiInRecruitingUseCasesSection-module__mFsa7q__cardTitle",
  "checkIcon": "AiInRecruitingUseCasesSection-module__mFsa7q__checkIcon",
  "header": "AiInRecruitingUseCasesSection-module__mFsa7q__header",
  "sectionSubtitle": "AiInRecruitingUseCasesSection-module__mFsa7q__sectionSubtitle",
  "sectionTitle": "AiInRecruitingUseCasesSection-module__mFsa7q__sectionTitle",
  "useCasesSection": "AiInRecruitingUseCasesSection-module__mFsa7q__useCasesSection",
});
